export default "__VITE_ASSET__CKSLkXVt__"